// extracted by mini-css-extract-plugin
export var circle = "_19-2";
export var icon = "_19-a";
export var iconHighlight = "_19-0";
export var lg = "_19-8";
export var md = "_19-7";
export var outline = "_19-4";
export var sm = "_19-6";
export var square = "_19-1";
export var xl = "_19-9";
export var xs = "_19-5";
export var xxs = "_19-3";